import React from 'react'
import { Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Button } from '@mui/material'
import { useForm, Controller, SubmitHandler } from 'react-hook-form'
import CustomerSelect from './CustomerSelect'
import { CustomerEntity } from 'types/CustomerEntity'

export type ConnectCustomerForm = {
    customer: CustomerEntity | null
}

function ConnectCustomerDialog({
    open,
    onClose,
    onSubmit,
}: {
    open: boolean
    onClose: () => void
    onSubmit: (val: ConnectCustomerForm) => void
}) {
    const {
        control,
        handleSubmit,
        formState: { errors },
        reset,
    } = useForm<ConnectCustomerForm>()

    const handleFormSubmit: SubmitHandler<ConnectCustomerForm> = (data) => {
        onSubmit(data)
        reset() // Reset form after submission
    }

    return (
        <Dialog open={open} onClose={onClose}>
            <DialogTitle>Koppla till kund</DialogTitle>
            <DialogContent>
                <DialogContentText sx={{ mb: 2 }}>Välj kund</DialogContentText>
                <form onSubmit={(event) => void handleSubmit(handleFormSubmit)(event)}>
                    <Controller
                        name='customer'
                        control={control}
                        defaultValue={null}
                        rules={{ required: 'Kund är obligatorisk' }}
                        render={({ field }) => (
                            <CustomerSelect
                                value={field.value}
                                onChange={field.onChange}
                                label='Kund'
                                error={!!errors.customer}
                                helperText={errors.customer?.message}
                            />
                        )}
                    />

                    <DialogActions>
                        <Button onClick={onClose} color='primary'>
                            Avbryt
                        </Button>
                        <Button type='submit' color='primary' variant='contained'>
                            Koppla
                        </Button>
                    </DialogActions>
                </form>
            </DialogContent>
        </Dialog>
    )
}

export default ConnectCustomerDialog
